<template>
	<!-- <div id="generate">
			<loader-report v-if="!isError" class="centeredLoader" loaderStyle="circle" loaderMessage="Buscando seu relatório"></loader-report>
			<loader-report v-if="isError" class="centeredLoader" loaderMessage="Erro ao gerar seu relatório"></loader-report>
	</div>-->
	<loader-report
		v-show="true"
		class="centeredLoader"
		loaderStyle="circle"
		:loaderMessage="$t('views.generateReport.centeredLoader1')"
	></loader-report>
</template>


<script>
import Loader from "./../../components/shared/default/Loader";
export default {
	components: {
		"loader-report": Loader
	},

	data: () => ({
		url: `${process.env.VUE_APP_HOST_FUNCTIONS_REPENSE}`,
		gameSetId: "",
		reportData: ""
		// gameSetId: '',
		// reportData: '',
		// isError: false
	}),
	async created() {
		const query = new URLSearchParams(window.location.search);
		let workspaceId = localStorage.getItem("workspaceId");
		let uid = localStorage.getItem("uid");
		const user = JSON.parse(localStorage.getItem("user"));
		let jobId = localStorage.getItem("jobId");
		let applicationId = localStorage.getItem("applicationId");
		const feedbackId = localStorage.getItem("feedbackId");
		// this.gameSetId = localStorage.getItem("gameSetId");
		let feedback = false;
		if(query.get("workspaceId") && query.get("uid")) {
			workspaceId = query.get("workspaceId");
			uid = query.get("uid");	
		}
	
		try {
			const gameSetReq = await this.$http.get(`${this.url}/game-sets?workspaceId=${workspaceId}&userId=${uid}`)
			this.gameSetId = gameSetReq.data ? gameSetReq.data.id : gameSetReq.body.id
		} catch (error) {
			//TODO: make a error message showing up instead console.log error
			// console.error("Error trying to get GAME SET ID:", error)
		}
		try {
			const reportReq = await this.$http.get(this.url + `/reports?gameSetId=${this.gameSetId}`);
		//   const gupyWorkspaces = [
		//     "sPCGDV1ja9639qzApX3E",
		//     "Oj6FEicMCYo4wCoFMSOq",
		//     "ffocEYR9N4uxEDkGodO6"
		//   ];
		//   user.id = uid;
		//   if (gupyWorkspaces.includes(workspaceId)) {
		//     const integrationApi = process.env.VUE_APP_INTEGRATION_SYSTEM;
		//     await this.$http.post(`${integrationApi}/gupy/send-result`, {
		//       gameSetId: this.gameSetId,
		//       workspaceId,
		//       user
		//     });
		//   }
		// console.log(`reportData: `, reportReq.body);
		this.reportData = reportReq.body;

		const feedbackReq = await this.$http.get( `${this.url}/feedbacks?userId=${uid}`);
		// console.log(`feedback req: `, feedbackReq);
		if (feedbackReq.body.fields) {
			feedback = true;
		}
		this.$router.push("/report/performance");
		} catch (error) {
		// console.log(`feedback error: `, error);
		if (error.body.response == "feedback(s) not found") {
			this.$router.push("/report/performance");
		}
		//TODO: make a error message showing up instead console.log error
		// console.log(
		// 	this.$t("views.generateReport.centeredLoader2"),
		// 	error.body.response
		// );
		}

		localStorage.setItem("report", JSON.stringify(this.reportData.fields));
		localStorage.setItem("feedback", JSON.stringify(feedback));
	}
};
</script>

<style lang="scss">
</style>
